<template>
    <div class="box-page">
        <div class="page-header with-underline">
            <div class="d-flex align-items-center justify-content-center">
                <span class="page-title">รายละเอียด</span>
            </div>
        </div>

        <div class="container">
            <div class="row">
                <div class="col-md-3">
                    <div class="ele-textbox">
                        <input type="text" name="partial_title" class="ele-textbox-input" v-model="member.partial_title" maxlength="50">
                        <label for="partial_title" class="ele-textbox-label with-require">คำนำหน้า</label>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="ele-textbox">
                        <input type="text" name="name" class="ele-textbox-input" v-model="member.name" maxlength="60">
                        <label for="name" class="ele-textbox-label with-require">ชื่อ</label>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="ele-textbox">
                        <input type="text" name="lastname" class="ele-textbox-input" v-model="member.lastname" maxlength="60">
                        <label for="lastname" class="ele-textbox-label with-require">นามสกุล</label>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="ele-textbox">
                        <input type="text" name="idno" class="ele-textbox-input" v-model="member.idNo" maxlength="13">
                        <label for="idno" class="ele-textbox-label with-require">เลขที่บัตรประชาชน</label>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="ele-textbox">
                        <input type="text" name="telephone" class="ele-textbox-input" v-model="member.telephone" disabled>
                        <label for="telephone" class="ele-textbox-label">เบอร์โทร</label>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="ele-textbox">
                        <input type="text" name="address_no" class="ele-textbox-input" v-model="member.address_no" maxlength="20">
                        <label for="address_no" class="ele-textbox-label">บ้านเลขที่</label>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="ele-textbox">
                        <input type="text" name="address_building" class="ele-textbox-input" v-model="member.address_building" maxlength="20">
                        <label for="address_building" class="ele-textbox-label">อาคาร</label>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="ele-textbox">
                        <input type="text" name="address_moo" class="ele-textbox-input" v-model="member.address_moo" maxlength="20">
                        <label for="address_moo" class="ele-textbox-label">หมู่</label>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="ele-textbox">
                        <input type="text" name="address_soi" class="ele-textbox-input" v-model="member.address_soi" maxlength="20">
                        <label for="address_soi" class="ele-textbox-label">ซอย</label>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="ele-textbox">
                        <input type="text" name="address_road" class="ele-textbox-input" v-model="member.address_road" maxlength="20">
                        <label for="address_road" class="ele-textbox-label">ถนน</label>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="ele-textbox">
                        <input type="text" id="district_manual_name" class="ele-textbox-input" v-model="member.district_manual_name">
                        <label for="district" class="ele-textbox-label">ตำบล/แขวง</label>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="ele-textbox">
                        <input type="text" id="amphur_manual_name" class="ele-textbox-input" v-model="member.amphur_manual_name">
                        <label for="amphoe" class="ele-textbox-label">อำเภอ/เขต</label>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="ele-textbox">
                        <input type="text" id="province_manual_name" class="ele-textbox-input" v-model="member.province_manual_name" maxlength="50">
                        <label for="province" class="ele-textbox-label">จังหวัด</label>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="ele-textbox">
                        <input type="text" id="zipcode" class="ele-textbox-input" v-model="member.zipcode" maxlength="5">
                        <label for="zipcode" class="ele-textbox-label">รหัสไปรษณีย์</label>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="ele-form-select">
                        <label for="bank_name" class="ele-label">ชื่อธนาคาร</label>
                        <div class="ele-box-select">
                            <select class="ele-select" name="bank_name" v-model="member.bankCode">
                                <option v-for="(itm, idx) in listBank" :key="idx"
                                :value="itm.short_name" v-text="itm.name"></option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="ele-textbox">
                        <input type="text" name="bank_name" class="ele-textbox-input" v-model="member.bankAccount" maxlength="13">
                        <label for="bank_name" class="ele-textbox-label">เลขบัญชี</label>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group form-goobank">
                        <label for="birthDateInput" style="order:0">วันเกิด</label>
                        <v-date-picker v-model="member.birthDate" locale="th" buddhist :popover="{ placement: 'bottom', visibility: 'click' }">
                            <input ref="birthDateInput" id="birthDateInput" name="birthDateInput" class="form-control" :value="birthDateDisplay" placeholder="กรุณาเลือกวันเกิด" @keydown.prevent="" 
                            :class="{ 'is-valid': (fields.birthDateInput && fields.birthDateInput.dirty) && !errors.has('birthDateInput'), 'is-invalid': errors.has('birthDateInput') }"
                            />
                        </v-date-picker>
                        <div v-show="errors.has('birthDateInput')" class="invalid-feedback" style="display:block">จำเป็นต้องกรอกและต้องมีอายุ 20 ปีบริบูรณ์</div>
                    </div>
                </div>
            </div>
            <div class="row text-center" style="margin-top:50px; margin-bottom:50px;">
                <div class="col-lg-3 col-md-3">
                    <div class="mb-2">
                        <label>บัตรประชาชนตัวจริง</label>
                    </div>
                    <img :src="member.imageIdCard" class="img-member cursor-pointer" :class="(!member.imageIdCard ? 'img-radius' : '')"
                    @click="openImg(member.imageIdCard)">
                </div>
                <div class="col-lg-3 col-md-3">
                    <div class="mb-2">
                        <label>สมุดบัญชีเงินฝาก</label>
                    </div>
                    <img :src="member.imageBookBank" class="img-member cursor-pointer" :class="(!member.imageBookBank ? 'img-radius' : '')"
                    @click="openImg(member.imageBookBank)">
                </div>
                <div class="col-lg-3 col-md-3">
                    <div class="mb-2">
                        <label>รูปตัวเองคู่บัตรประชาชน</label>
                    </div>
                    <img :src="member.imageAvatar" class="img-member cursor-pointer" :class="(!member.imageAvatar ? 'img-radius' : '')"
                    @click="openImg(member.imageAvatar)">
                </div>
                <div class="col-lg-3 col-md-3">
                    <div class="mb-2">
                        <label>รูปถ่ายสลิปค่าสมัคร 100 บาท</label>
                    </div>
                    <img :src="member.imageBankSlip" class="img-member cursor-pointer" :class="(!member.imageBankSlip ? 'img-radius' : '')"
                    @click="openImg(member.imageBankSlip)">
                </div>
                <div class="col-lg-4 col-md-6" v-if="member.regisType == 'juristic_person'">
                    <div class="mb-2">
                        <label>หนังสือรับรองเอกสารนิติบุคคล 1</label>
                    </div>
                    <img class="img-member cursor-pointer" v-if="member.imageCorpCert == '/goobank_assets/common/img/avatar.png'" src="/goobank_assets/common/img/avatar.png" />
                    <img class="img-member cursor-pointer" v-else src="/goobank_assets/assets/default-pdf-uploaded.png" @click="openPDF(member.imageCorpCert)" />
                </div>
                <div class="col-lg-4 col-md-6" v-if="member.regisType == 'juristic_person'">
                    <div class="mb-2">
                        <label>เอกสารแต่งตั้งตัวแทนนิติบุคคล 1</label>
                    </div>
                    <img class="img-member cursor-pointer" v-if="member.imageDocument == '/goobank_assets/common/img/avatar.png'" src="/goobank_assets/common/img/avatar.png" />
                    <img class="img-member cursor-pointer" v-else src="/goobank_assets/assets/default-pdf-uploaded.png" @click="openPDF(member.imageDocument)" />
                </div>
            </div>
            <div class="text-center" style="margin-top:50px; margin-bottom:50px;">
                <template v-if="!readOnly">
                    <button class="btn btn-small" @click="verifyRegister">ยืนยัน</button>
                    <button class="btn btn-small" @click="rejectRegister">ไม่ยืนยัน</button>
                </template>
                <button class="btn btn-small" @click="hideDetail">ย้อนกลับ</button>
                <button class="btn btn-small" @click="updateMember">บันทึก</button>

                <button class="ml-3 btn btn-small" @click="viewPdfStatement">โหลดสเตจเม้นท์</button>
            </div>
        </div>
    
        <div class="modal-group">
            <div id="modal_reject_new_member_reason" class="modal fade">
                <div class="modal-dialog modal-md">
                    <div class="modal-content">
                        <!-- Modal Header -->
                        <div class="modal-header">
                            <div class="d-flex w-100 justify-content-between">
                                <div>
                                    <h4 class="modal-title">ไม่ผ่านเพราะ...</h4>
                                </div>
                            </div>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">
                                    <i class="icon-close"></i>
                                </span>
                            </button>
                        </div>
                        <!-- Modal body -->
                        <div class="modal-body">
                            <div class="container">
                                <div class="mb-2">เลือกเหตุผลในการไม่อนุมัติการสมัคร</div>
                                <select v-model="reason" class="form-control">
                                    <option>อายุไม่ถึง 20 ปี บริบูรณ์ หรือ วัน/เดือน/ปีเกิด ไม่ตรงกับบัตรประชาชน</option>
                                    <option>ที่อยู่ที่กรอกไม่ตรงกับบัตรประชาชน</option>
                                    <option>กรองข้อมูล ชื่อ-นามสกุล เป็นภาษาอื่นที่ไม่ใช่ภาษาไทย</option>
                                    <option>รูปภาพ "บัตรประชาชนตัวจริง" ไม่ถูกต้อง หรือไม่ชัดเจน</option>
                                    <option>รูปภาพ "สมุดบัญชี" ไม่ถูกต้อง ไม่ใช่ของผู้สมัคร หรือไม่ชัดเจน</option>
                                    <option>รูปภาพที่ต้องอัพโหลดทั้ง 4 ภาพ ไม่ถูกต้อง หรือไม่ชัดเจน</option>
                                    <option>ข้อมูลผู้สมัครมีอยู่แล้วในระบบ</option>
                                    <option>ข้อมูลในบางช่องตกหล่น หรือไม่ได้กรอกมา</option>
                                    <option>รูปตัวเองคู่บัตรประชาชน ไม่ถูกต้อง หรือไม่ชัดเจน</option>
                                    <option>รูปถ่ายสลิปค่าสมัคร 100 บาท” ไม่ถูกต้อง หรือไม่ชัดเจน</option>
                            </select>
                            </div>
                        </div>

                        <!-- Modal footer -->
                        <div class="modal-footer">
                            <div>
                                <button type="button" class="btn btn-small btn-dismiss" data-dismiss="modal">ยกเลิก</button>
                                <button type="button" class="btn btn-small btn-ok" data-dismiss="modal" @click="confirmRejectRegister">ตกลง</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    
</template>

<script>
import ShareFunction from '../../../share-function';
import dateFormat from '../../../components/utils/date.js';

export default {
    data: function () {
        return {
            listBank: [],
            reason: '',
            member: {
                id: null,
                regisType: '',
                idNo: '',
                telephone: '',
                birthDate: '',
                zipcode: '',
                address: '',
                address_no: '',
                address_building: '',
                address_moo: '',
                address_soi: '',
                address_road: '',
                districtId: '',
                district: '',
                amphoeId: '',
                amphoe: '',
                provinceId: '',
                province: '',
                bankCode: '',
                bankName: '',
                bankAccount: '',
                imageIdCard: '',
                imageBookBank: '',
                imageAvatar: '',
                imageBankSlip: '',
                imageCorpCert: '',
                imageDocument: '',
            },
            cloneMember: {},
        };
    },
    created: function() {
        this.loadBankList();
    },
    computed: {
        birthDateDisplay () {
            if(this.member.birthDate) {
                return dateFormat.thaidate(this.member.birthDate);
            } else {
                return '';
            }
        },
    },
    methods: {
        viewPdfStatement() {
            const period = 3;
            const url = `${this.baseUrl}/admin/api/view-statement?memberId=${this.member.id}&period=${period}`

            window.open(url, '_blank')
        },
        loadBankList() {
            return axios.get(`${this.baseUrl}/index/api/list-bank`)
            .then(({ data }) => {
                console.log('list-bank', data);
                if (data != null && data.data) {
                    this.listBank = data.data;
                }
            });
        },
        showMemberDetail(memberID) {
            this.member.id = memberID;
            const params = {
                memberID: this.member.id,
            };
            return axios.post(`${this.baseUrl}/admin/api/get-member-detail`, params).then(({ data }) => {
                console.log('get-member-detail', data.data);
                if (data != null && data.data) {
                    const d = data.data;
                    this.member.partial_title = d.partial_title;
                    this.member.name = d.name;
                    this.member.lastname = d.lastname;
                    this.member.telephone = d.telephone;
                    this.member.regisType = d.register_as;
                    this.member.idNo = d.citizen_id;
                    this.member.address = this.getAddress(d.address_no, d.address_building, d.address_moo, d.address_soi, d.address_road);
                    this.member.address_no = d.address_no;
                    this.member.address_building = d.address_building;
                    this.member.address_moo = d.address_moo;
                    this.member.address_soi = d.address_soi;
                    this.member.address_road = d.address_road;
                    this.member.district_manual_name = d.district_manual_name;
                    this.member.amphur_manual_name = d.amphur_manual_name;
                    this.member.province_manual_name = d.province_manual_name;
                    this.member.zipcode = d.zipcode;
                    this.member.bankCode = d.bank_code;
                    this.member.bankName = d.bank_name;
                    this.member.bankAccount = d.bank_account;

                    if(d.birth_date == null) {
                        this.member.birthDate = null;
                    } else {
                        this.member.birthDate = moment(d.birth_date).toDate();
                    }

                    this.member.imageIdCard = this.getFullPathImage(d.image_idcard);
                    this.member.imageBookBank = this.getFullPathImage(d.image_bookbank);
                    this.member.imageAvatar = this.getFullPathImage(d.image_avatar);
                    this.member.imageBankSlip = this.getFullPathImage(d.image_bank_slip);
                    this.member.imageCorpCert = this.getFullPathImage(d.image_corp_cert);
                    this.member.imageDocument = this.getFullPathImage(d.image_document);
                    this.cloneMember = Object.assign({}, this.member);
                }
            });
        },
        getAddress(addressNo, addressBuilding, addressMoo, addressSoi, addressRoad) {
            addressNo = (addressNo ? 'บ้านเลขที่ ' + addressNo : '');
            addressBuilding = (addressBuilding ? 'อาคาร ' + addressBuilding : '');
            addressMoo = (addressMoo ? 'หมู่ ' + addressMoo : '');
            addressSoi = (addressSoi ? 'ซ. ' + addressSoi : '');
            addressRoad = (addressRoad ? 'ถ. ' + addressRoad : '');
            return [addressNo, addressBuilding, addressMoo, addressSoi, addressRoad].filter(x => x).join(' ');
        },
        hideDetail(isLoadList = false) {
            this.$emit('hideDetail', isLoadList);
        },
        verifyRegister() {
            const vm = this;
            $.confirmbox({
                title: 'ยืนยัน',
                msg: 'อนุมัติการสมัครใช่หรือไม่ ?',
                confirmEvent: () => {
                    axios.post(`${this.baseUrl}/admin/api/verify-register`, { id: this.member.id }).then(({ data }) => {
                        if (data != null && data.success) {
                            alertbox('บันทึกสำเร็จ');
                            this.hideDetail(true);
                        }
                    });
                }
            });
        },
        rejectRegister() {
            this.reason = '';
            $('#modal_reject_new_member_reason').modal('show');
        },
        confirmRejectRegister() {
            const vm = this;
            $.confirmbox({
                title: 'ยืนยัน',
                msg: 'ปฏิเสธการสมัครใช่หรือไม่ ?',
                confirmEvent: () => {
                    axios.post(`${this.baseUrl}/admin/api/reject-register`, { id: this.member.id, reason: vm.reason }).then(({ data }) => {
                        if (data != null && data.success) {
                            alertbox('บันทึกสำเร็จ');
                            this.hideDetail(true);
                        }
                    });
                }
            });
        },
        getFullPathImage(filename) {
            let result = '/goobank_assets/common/img/avatar.png';
            if (filename) {
                result = /^https?:\/\//i.test(filename)
                    ? filename
                    : `${this.baseUrl}/${this.storagePath}${filename}`;
            }
            return result;
        },
        openImg(src) {
            ShareFunction.openImg(src);
        },
        openPDF(src) {
            ShareFunction.openPDF(src);
        },
        updateMember() {
            let params = {
                id: this.member.id
            };
            Object.keys(this.member).forEach(key => {
                if (this.member[key] != this.cloneMember[key]) {
                    params[key] = this.member[key];
                }
            });
            return axios.post(`${this.baseUrl}/admin/api/update-member`, params).then(({ data }) => {
                if (data.success === true) {
                    alertbox('บันทึกสำเร็จ');
                    this.hideDetail(true);
                }
            });
        },
    },
    props: {
        baseUrl: '',
        storagePath: '',
        readOnly: false,
    },
}

</script>
<style lang="scss" scoped>
    .img-member {
        width: 200px;
        height: 200px;
    }
    .img-radius {
        border-radius: 50%;
    }
</style>
